





import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ScrollSpy extends Vue {
  items = []
  currentItem = null
  lastActiveItem = null

  @Prop({ type: String, default: '.content' }) container
  @Prop({ type: String, default: 'is-active' }) activeClass
  @Prop({ type: Number, default: 1 }) offset

  get scrollContainer() {
    return document.querySelector(this.container)
  }

  mounted() {
    this.initItems()
    this.scrollContainer.addEventListener('scroll', this.onScroll)

    const { hash } = window.location
    if (hash) {
      const target = document.getElementById(hash.substr(1))
      const element = document.querySelector(`a[href='${window.location.hash}']`)
      if (!target) {
        return
      }
      this.updateScrollPosition(target)
    }
  }

  updated() {
    this.initItems()
  }

  beforeDestroy() {
    this.scrollContainer.removeEventListener('scroll', this.onScroll)
  }

  onScroll(event) {
    this.currentItem = this.getItemInsideWindow()

    if (this.currentItem) {
      if (this.currentItem !== this.lastActiveItem) {
        this.removeActiveClass()
        this.lastActiveItem = this.currentItem
      }
      this.currentItem.classList.add(this.activeClass)
    }
  }

  getItemInsideWindow() {
    let currentItem

    this.items.forEach((item) => {
      const target = document.getElementById(item.hash.substr(1))
      // Add 80px because of fixed
      const isScreenPastSection = this.scrollContainer.scrollTop + 80 >= this.getOffsetTop(target) - this.offset
      if (isScreenPastSection) {
        currentItem = item
      }
    })

    return currentItem
  }

  initItems() {
    this.items = Array.from(this.$el.querySelectorAll('.scroll-item'))

    this.items.forEach((item) => {
      item.addEventListener('click', this.handleClick)
    })

    this.removeActiveClass()
    this.currentItem = this.getItemInsideWindow()

    if (this.currentItem) {
      this.currentItem.classList.add(this.activeClass)
    }
  }

  updateScrollPosition(target) {
    const top = target.offsetTop
    this.scrollContainer.scrollTop = top - this.offset
  }

  handleClick(event) {
    event.preventDefault()

    const { hash } = event.currentTarget
    const target = document.getElementById(hash.substr(1))

    this.scrollContainer.removeEventListener('scroll', this.onScroll)

    this.removeActiveClass()
    event.currentTarget.classList.add(this.activeClass)

    this.updateScrollPosition(target)
    this.scrollContainer.addEventListener('scroll', this.onScroll)

    if (window.history.replaceState) {
      window.history.replaceState(null, null, hash)
    } else {
      window.location.hash = hash
    }
  }

  getOffsetTop(element) {
    let yPosition = 0
    let nextElement = element

    while (nextElement) {
      yPosition += (nextElement.offsetTop)
      nextElement = nextElement.offsetParent
    }

    return yPosition
  }

  removeActiveClass() {
    this.items.forEach((item) => {
      item.classList.remove(this.activeClass)
    })
  }
}
